<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { BaseButton, BaseIcon } from "@/components";
import PackageSettigns from "./PackageSettigns";
import { CurrencySymbol } from "../../constants";
import InfoArea from "../base/InfoArea.vue";
import mixins from "../../mixins/";

export default {
  name: "DataRequestItem",
  mixins: [mixins],
  components: {
    BaseButton,
    BaseIcon,
    PackageSettigns,
    InfoArea,
  },
  props: {
    dataItem: Object,
  },
  data() {
    return {
      packageDetail: null,
      marketInfo: null,
      isPopupVisible: false,
      infoText:
        "Fatura dönemi içerisinde, iptal edilen lisanslar hemen iptal edilse bile ücretlendirme yansımaktadır ve iptal edilen lisanlar ay sonuna kadar kullanılabilmektedir.",
      cusId: null,
      userType: null,
      isActive: false,
      pricesText: window.innerWidth < 768 ? "Tutar" : "Fiyat",
      isMobile: false,
    };
  },
  mounted() {
    if (this.$route.params.customerId !== undefined) {
      this.cusId = this.$route.params.customerId;
    }
    let selectedFilter = {};
    if (
      this.generalFilter.filter !== undefined &&
      this.generalFilter.filter !== {}
    ) {
      selectedFilter = this.generalFilter.filter;
    }
    this.setGeneralFilter({ page: 1, size: 100, filter: selectedFilter });
    this.userType = this.getUserType;
    window.addEventListener("resize", this.setMobileState(window.innerWidth));
    if (window.innerWidth <= 768) {
      this.isMobile = true;
    }
  },
  computed: {
    ...mapGetters([
      "getPackageInfo",
      "getMarketInfo",
      "purchaseChangeStartDate",
      "generalFilter",
      "getUserInfo",
    ]),
    currencySymbol() {
      return CurrencySymbol;
    },
    getDataItemId() {
      return String(this.dataItem.id);
    },
    getSelectedPacks() {
      return [
        ...this.dataItem.research.map((d) => d.researchFeature.name),
        ...this.dataItem.foreignIndice.map((d) => d.foreignIndiceFeature.name),
        ...this.dataItem.algorithm.map((d) => d.algorithmFeature.name),
      ];
    },
    getSelectedTerminalNumber() {
      return this.dataItem.algorithm.map((d) => d.terminalNumber);
    },
    totalPriceDollar() {
      return this.dataItem?.price?.prices?.filter(
        (e) => e.info === this.currencySymbol.dolar
      )[0];
    },
    totalPriceTl() {
      let turkishLiraList = [];
      const pricesToCheck = this.dataItem?.price?.prices;

      if (pricesToCheck != null) {
        pricesToCheck.forEach((key) => {
          if (key?.info === "₺" && key != undefined) {
            turkishLiraList.push(key.totalPrice);
          }
        });
      }

      return turkishLiraList.reduce((a, c) => a + c, 0);
    },
    totalPriceEuro() {
      return this.dataItem?.price?.prices?.filter(
        (e) => e.info === this.currencySymbol.euro
      )[0];
    },
    totalPriceCalc() {
      let totalDollar =
        this.totalPriceDollar != null
          ? " + " +
            this.formatPriceDollar(this.totalPriceDollar?.totalPrice) +
            " USD"
          : "";
      let totalEuro =
        this.totalPriceEuro != null
          ? " + " +
            this.formatPriceEuro(this.totalPriceEuro?.totalPrice) +
            " EUR"
          : "";
      return (
        this.formatPrice(this.totalPriceTl) + " TL" + totalDollar + totalEuro
      );
    },
    mergedPackagesNames() {
      const list = [];

      const platform = this.dataItem.foreignIndice?.map((i) => i?.name);
      const algorithm = this.dataItem.algorithm?.map((i) => i?.name);
      const researchList = this.dataItem.research?.map((i) => i?.name);

      const marketFeature =
        this.dataItem.package?.map((i) => i?.marketFeature?.name) || [];

      const filteredMarketFeature = marketFeature.filter(
        (name) => name !== undefined
      );
      const filteredAlgorithm = algorithm.filter((name) => name !== undefined);
      const filteredPlatform = platform.filter((name) => name !== undefined);
      const filteredResearchList = researchList.filter(
        (name) => name !== undefined
      );

      if (filteredMarketFeature.length > 0) {
        const removeDuplicated = filteredMarketFeature.filter(function (item) {
          if (!this.has(item)) {
            this.set(item, true);
            return true;
          }
        }, new Map());
        list.push(...removeDuplicated);
      }

      if (filteredPlatform.length > 0) {
        const removeDuplicated = filteredPlatform.filter(function (item) {
          if (!this.has(item)) {
            this.set(item, true);
            return true;
          }
        }, new Map());
        list.push(...removeDuplicated);
      }

      if (filteredResearchList.length > 0) {
        const removeDuplicated = filteredResearchList.filter(function (item) {
          if (!this.has(item)) {
            this.set(item, true);
            return true;
          }
        }, new Map());
        list.push(...removeDuplicated);
      }

      if (filteredAlgorithm.length > 0) {
        const removeDuplicated = filteredAlgorithm.filter(function (item) {
          if (!this.has(item)) {
            this.set(item, true);
            return true;
          }
        }, new Map());
        list.push(...removeDuplicated);
      }
      return list;
    },
    mergedForTableData() {
      const list = [];
      const nextMonthList = [];
      let multipleLicenceFeatures = [];
      const processPackageItem = (item) => {
        const createLicenceFeature = (name, price, priceInfo) => {
          let currencySymbol = "";
          if (priceInfo === "₺") {
            currencySymbol = "TL";
          } else if (priceInfo === "€") {
            currencySymbol = "EUR";
          } else if (priceInfo === "$") {
            currencySymbol = "USD";
          }
          if (name === "Osmanlı Pro Osmanlı Pro Ekranları") {
            name = "Osmanlı Pro - Osmanlı Pro Ekranları";
          }
          if (
            name !== undefined &&
            price !== undefined &&
            currencySymbol !== undefined
          ) {
            multipleLicenceFeatures.push({
              name,
              startDate: item.startDate,
              endDate: item.endDate,
              totalPrice: `${price} ${currencySymbol}`,
            });
          }
        };
        const processFeature = (feature) => {
          const featureName = item[feature]?.name;
          const featurePrice = item[feature]?.price;
          const featureInfo = item[feature]?.info;
          if (
            featureName !== undefined &&
            featurePrice !== undefined &&
            featureName != "Yok"
          ) {
            createLicenceFeature(
              item.marketFeature?.name + " " + featureName,
              featurePrice,
              featureInfo
            );
          }
        };
        processFeature("perspectiveFeature");
        processFeature("vendorFeature");
      };
      if (this.dataItem.package.length > 0) {
        this.dataItem.package.forEach(processPackageItem);
      }
      const filterUndefined = (arr) => arr.filter((item) => item !== undefined);
      const filteredPlatform = filterUndefined(
        this.dataItem.foreignIndice?.map((i) => i)
      );
      const filteredResearchList = filterUndefined(
        this.dataItem.research?.map((i) => i)
      );
      const filteredAlgoList = filterUndefined(
        this.dataItem.algorithm?.map((i) => i)
      );

      const nextMonthListFilter = multipleLicenceFeatures.filter(
        (o) => new Date(o.startDate) > new Date()
      );
      const nextMonthResearch = filteredResearchList.filter(
        (o) => new Date(o.startDate) > new Date()
      );
      const nextMonthPlatform = filteredPlatform.filter(
        (o) => new Date(o.startDate) > new Date()
      );
      const nextMonthAlgo = filteredAlgoList.filter(
        (o) => new Date(o.startDate) > new Date()
      );

      const prevNowItems = multipleLicenceFeatures.filter(
        (o) => new Date(o.startDate) < new Date()
      );

      const prevMonthResearch = filteredResearchList.filter(
        (o) => new Date(o.startDate) < new Date()
      );
      const prevMonthPlatform = filteredPlatform.filter(
        (o) => new Date(o.startDate) < new Date()
      );
      const prevMonthAlgo = filteredAlgoList.filter(
        (o) => new Date(o.startDate) < new Date()
      );
      list.push(
        ...prevNowItems,
        ...prevMonthPlatform,
        ...prevMonthResearch,
        ...prevMonthAlgo
      );
      nextMonthList.push(
        ...nextMonthListFilter,
        ...nextMonthPlatform,
        ...nextMonthResearch,
        ...nextMonthAlgo
      );
      return [list, nextMonthList];
    },
    getUserType() {
      return this.getUserInfo.memberType;
    },
  },
  methods: {
    ...mapActions([
      "getPackageDetail",
      "getDraftPackageDetail",
      "getMarket",
      "cancelPackage",
      "getAllPackages",
      "getPurchaseChangeStartDate",
    ]),
    ...mapMutations(["setGeneralFilter", "setIsPurchaseOrUpgradeHappend"]),
    addCart(dataItemId) {
      if (
        this.$route.name == "CustomerDetail" ||
        this.$route.name == "OvdHome"
      ) {
        this.getPackageDetail([dataItemId, this.cusId]).then(() => {
          this.packageDetail = this.getPackageInfo;
          this.getMarket([
            this.packageDetail.application.applicationId,
            this.packageDetail.platform.platformId,
            this.cusId,
          ]).then(() => {
            this.marketInfo = this.getMarketInfo;
          });
          this.isPopupVisible = true;
          this.$emit("checkIsPopupOpen", true);
        });
      } else {
        this.getDraftPackageDetail([dataItemId, this.cusId]).then(() => {
          this.packageDetail = this.getPackageInfo;
          this.getMarket([
            this.packageDetail.application.applicationId,
            this.packageDetail.platform.platformId,
            this.cusId,
          ]).then(() => {
            this.marketInfo = this.getMarketInfo;
          });
          this.isPopupVisible = true;
          this.$emit("checkIsPopupOpen", true);
        });
      }
    },
    cancel(purchaseId) {
      this.cancelPackage(purchaseId).then((res) => {
        if (res.data === true) {
          this.getAllPackages(this.cusId);
          this.$toast.success("İptal Edildi");
          this.closeModal();
        }
      });
    },
    setMobileState(resizedWidth) {
      if (resizedWidth <= 768) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    closePopup() {
      this.isPopupVisible = false;
      this.$emit("checkIsPopupOpen", false);
    },
    showModal(packageStatus) {
      if (packageStatus === 5) {
        this.$toast.error("Paketiniz zaten pasif durumdadır.");
      } else {
        this.$modal.show(packageStatus);
      }
    },
    closeModal() {
      this.$emit("checkIsPopupOpen", false);
      this.$modal.hide(this.getDataItemId);
      this.setIsPurchaseOrUpgradeHappend(false);
    },
    changeStartDate(val) {
      const args = {
        PurchaseNumber: this.dataItem.purchaseNo,
        DateSelection: val,
        cusId: this.cusId,
      };
      this.getPurchaseChangeStartDate(args).then((res) => {
        if (res?.error) {
          this.$toast.error(res.message);
        } else {
          this.$toast.success("Başarıyla güncelleme yapıldı.");
          this.getAllPackages(this.cusId);
        }
      });
    },
    getTime(dateTime, formatType) {
      let stringDateTime = String(dateTime);
      let generateMomentDate = this.$moment(new Date(stringDateTime)).format(
        formatType
      );
      return generateMomentDate;
    },
    accordionToggle() {
      this.isActive = !this.isActive;
    },
  },
};
</script>

<template>
  <div class="data-request-item">
    <div
      class="data-request-item__top"
      :class="{ wEndDate: !dataItem.package.length && dataItem.endDate }"
    >
      <div
        class="left"
        :class="getSelectedTerminalNumber.length >= 1 ? 'flex-04' : ''"
      >
        <div class="section section-0">
          <img
            v-if="dataItem && dataItem.imageUrl"
            alt="product image"
            :src="dataItem.imageUrl"
          />
          <img
            v-else-if="dataItem && dataItem.application.imageUrl"
            alt="product image"
            :src="dataItem.application.imageUrl"
          />
          <base-icon v-else name="no-image" />
        </div>
        <div class="section section-main">
          <div class="section section-1">
            <h5>{{ dataItem.title }}</h5>
            <span>{{ dataItem.subtitle }}</span>
          </div>
        </div>
        <div
          class="right for-button"
          v-if="
            dataItem.packageStatus.id !== 6 &&
            dataItem.packageStatus.id !== 8 &&
            isMobile
          "
        >
          <div class="col">
            <div
              :id="'button-area-' + dataItem.purchaseNo"
              class="button-area"
              :class="{
                'd-none': dataItem.packageStatus.id === 6,
              }"
              v-if="dataItem.packageStatus.id !== 8"
            >
              <base-icon name="gear" />
              <span class="text">Düzenle</span>
              <div class="dropdown">
                <div
                  :id="'dropdown-item-1-' + dataItem.id"
                  class="dropdown-item"
                  v-if="
                    (dataItem.packageType === 1) &
                      (dataItem.packageStatus.id !== 6) &&
                    dataItem.application.id !== 2
                  "
                  @click="addCart(dataItem.id)"
                >
                  <span class="dropdown-item__text">Lisans Ekle/Çıkar</span>
                </div>
                <div
                  :id="'dropdown-item-2-' + dataItem.id"
                  class="dropdown-item"
                  @click="showModal(getDataItemId)"
                  v-if="dataItem.packageStatus.id == 2"
                >
                  <span class="dropdown-item__text">İptal Et</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div
          class="col"
          v-if="
            getSelectedTerminalNumber.length > 0 &&
            !getSelectedTerminalNumber.includes(null)
          "
        >
          <h6>Terminal No</h6>
          <span>{{ getSelectedTerminalNumber.toString() }}</span>
        </div>
        <div class="col">
          <h6 class="bold">Paket No</h6>
          <span>{{ dataItem.purchaseNo }}</span>
        </div>
        <div class="col" v-if="!dataItem.package.length && dataItem.startDate">
          <h6 class="bold">Başlangıç Tarihi</h6>
          <span>{{ getTime(dataItem.startDate, "DD/MM/YYYY") }}</span>
        </div>
        <div class="col" v-if="!dataItem.package.length && dataItem.endDate">
          <h6 class="bold">Bitiş Tarihi</h6>
          <span>{{ getTime(dataItem.endDate, "DD/MM/YYYY") }}</span>
        </div>
        <div class="col">
          <h6 class="bold">Talep Tarihi</h6>
          <span v-if="dataItem.requestDate">
            {{ getTime(dataItem.requestDate, "DD/MM/YYYY") }}
          </span>
          <span v-else>-</span>
        </div>

        <div class="col">
          <h6 class="bold">Düzenleme Tarihi</h6>
          <span v-if="dataItem.updatedAt">
            {{ getTime(dataItem.updatedAt, "DD/MM/YYYY") }}
          </span>
          <span v-else>-</span>
        </div>
      </div>
      <div
        class="right for-button"
        v-if="
          dataItem.packageStatus.id !== 6 &&
          dataItem.packageStatus.id !== 8 &&
          !isMobile
        "
      >
        <div class="col">
          <div
            :id="'button-area-' + dataItem.purchaseNo"
            class="button-area"
            :class="{
              'd-none': dataItem.packageStatus.id === 6,
            }"
            v-if="dataItem.packageStatus.id !== 8"
          >
            <base-icon name="gear" />
            <span class="text">Düzenle</span>
            <div class="dropdown">
              <div
                :id="'dropdown-item-1-' + dataItem.id"
                class="dropdown-item"
                v-if="
                  dataItem.packageType === 1 &&
                  dataItem.packageStatus.id !== 6 &&
                  dataItem.application.id !== 2
                "
                @click="addCart(dataItem.id)"
              >
                <span class="dropdown-item__text">Lisans Ekle/Çıkar</span>
              </div>
              <div
                :id="'dropdown-item-2-' + dataItem.id"
                class="dropdown-item"
                @click="showModal(getDataItemId)"
                v-if="dataItem.packageStatus.id == 2"
              >
                <span class="dropdown-item__text">İptal Et</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="right for-button"></div>
    </div>
    <div class="data-request-item__middle">
      <div class="left">
        <div class="item">
          <span>Bes Yatırım Fonu:</span>
          <strong
            >{{ formatPrice(dataItem.price.totalFundAmount) || 0 }} TL</strong
          >
        </div>
        <div class="item">
          <span>veya</span>
        </div>
        <div class="item">
          <span>Komisyon:</span>
          <strong>
            {{ formatPrice(dataItem.price.totalCommissionAmount) || 0 }}
            TL
          </strong>
        </div>
      </div>
      <div class="right">
        <div
          class="item integration-warning"
          v-if="!dataItem.isSuccessfulIntegration"
        >
          <div class="tag tooltip">
            <div class="tooltiptext">
              <div class="texts">
                {{ dataItem.productName }} sisteminden kaynaklı bir hata
                alınmaktadır. Lütfen daha sonra tekrar deneyiniz.
              </div>
            </div>
            <span class="text">
              <base-icon name="bell-fill" class="icon"></base-icon>
            </span>
          </div>
        </div>
        <div class="item">
          <h3 class="data-request-item__price">
            <span class="data-request-item__price__text">Paket Tutarı:</span>
            {{ totalPriceCalc || 0 }}
          </h3>
        </div>
        <div class="item">
          <span class="data-request-item__status">
            <span class="data-request-item__status__text">Paket Durumu:</span>
            <span
              class="data-request-item__status__stat"
              :class="[
                'request',
                {
                  active: dataItem.packageStatus.id == 2 ? true : '',
                  passive: dataItem.packageStatus.id == 8 ? true : '',
                },
              ]"
              >{{ dataItem.packageStatus.name }}</span
            >
          </span>
        </div>
      </div>
    </div>

    <div class="data-request-item__bottom" v-if="dataItem.package.length">
      <div class="left package-container">
        <div class="item">
          <strong>Paketler:</strong>
          <span
            class="items"
            v-for="(item, index) in mergedPackagesNames"
            :key="item.id"
            :class="{ hide: isActive }"
          >
            {{ item }}
            <span
              v-if="index != mergedPackagesNames.length - 1"
              class="seperator"
            ></span>
          </span>
        </div>
      </div>
      <div class="right" @click="accordionToggle">
        <base-icon
          :class="['toggle', { active: isActive }]"
          name="arrow-green"
        />
      </div>
      <div class="data-request-item__bottom__packages">
        <div :class="['accordion-wrapper', isActive ? 'active' : '']">
          <div
            :class="[
              'accordion-wrapper__row caption',
              isActive ? 'active' : '',
            ]"
            v-if="mergedForTableData[0].length"
          >
            <div class="accordion-wrapper__row__cell caption">Paket Adı:</div>
            <div class="accordion-wrapper__row__cell caption">
              Başlangıç Tarihi:
            </div>
            <div class="accordion-wrapper__row__cell caption">
              Bitiş <br class="xs" />Tarihi:
            </div>
            <div class="accordion-wrapper__row__cell caption">
              <span class="my__price">{{ pricesText }}</span>
            </div>
          </div>
          <div class="accordion-content active">
            <div
              class="accordion-wrapper__row"
              :key="item[index]"
              v-for="(item, index) in mergedForTableData[0]"
            >
              <div class="accordion-wrapper__row__cell">
                <span v-if="typeof item == 'object'">
                  <span v-if="item.name">{{ item.name }} </span>
                </span>
                <span v-else>{{ item }}</span>
              </div>
              <div class="accordion-wrapper__row__cell" v-if="item.startDate">
                {{ getTime(item.startDate, "DD/MM/YYYY") }}
              </div>
              <div class="accordion-wrapper__row__cell" v-else>-</div>
              <div class="accordion-wrapper__row__cell" v-if="item.endDate">
                {{ getTime(item.endDate, "DD/MM/YYYY") }}
              </div>
              <div class="accordion-wrapper__row__cell" v-else>-</div>
              <div class="accordion-wrapper__row__cell" v-if="item.totalPrice">
                <span class="my__price">
                  <span class="my__price-text">{{ pricesText }}:</span>
                  {{ item.totalPrice }}
                </span>
              </div>
              <div class="accordion-wrapper__row__cell" v-if="item.price">
                <span class="my__price"
                  ><span class="my__price-text">{{ pricesText }}:</span>
                  {{ item.price }}</span
                >
                <span v-if="item.info == '₺'">&nbsp;TL</span>
                <span v-else-if="item.info == '€'">&nbsp;EUR</span>
                <span v-else-if="item.info == '$'">&nbsp;USD</span>
              </div>
              <div
                class="accordion-wrapper__row__cell"
                v-if="!item.totalPrice && !item.price"
              >
                <span class="my__price">-</span>
              </div>
            </div>
            <div
              :class="[
                'accordion-wrapper__row caption',
                isActive ? 'active' : '',
              ]"
              v-if="mergedForTableData[1].length"
            >
              <div class="accordion-wrapper__row__cell caption">
                Paket Adı:
                <span>(Gelecek Ay)</span>
              </div>
              <div
                class="accordion-wrapper__row__cell caption"
                v-if="mergedForTableData[0].length"
              ></div>
              <div v-else class="accordion-wrapper__row__cell caption">
                Başlangıç Tarihi:
              </div>
              <div
                class="accordion-wrapper__row__cell caption"
                v-if="mergedForTableData[0].length"
              ></div>
              <div class="accordion-wrapper__row__cell caption" v-else>
                Bitiş <br class="xs" />Tarihi:
              </div>
              <div
                class="accordion-wrapper__row__cell caption"
                v-if="mergedForTableData[0].length"
              ></div>
              <div class="accordion-wrapper__row__cell caption" v-else>
                <span class="my__price">{{ pricesText }}</span>
              </div>
            </div>
            <div
              class="accordion-wrapper__row"
              :key="item[index]"
              v-for="(item, index) in mergedForTableData[1]"
            >
              <div class="accordion-wrapper__row__cell">
                <span v-if="typeof item == 'object'">
                  <span v-if="item.name">{{ item.name }} </span>
                </span>
                <span v-else>{{ item }}</span>
              </div>
              <div class="accordion-wrapper__row__cell" v-if="item.startDate">
                {{ getTime(item.startDate, "DD/MM/YYYY") }}
              </div>
              <div class="accordion-wrapper__row__cell" v-else>-</div>
              <div class="accordion-wrapper__row__cell" v-if="item.endDate">
                {{ getTime(item.endDate, "DD/MM/YYYY") }}
              </div>
              <div class="accordion-wrapper__row__cell" v-else>-</div>
              <div class="accordion-wrapper__row__cell" v-if="item.totalPrice">
                <span class="my__price">
                  <span class="my__price-text">{{ pricesText }}:</span>
                  {{ item.totalPrice }}
                </span>
              </div>
              <div class="accordion-wrapper__row__cell" v-if="item.price">
                <span class="my__price"
                  ><span class="my__price-text">{{ pricesText }}:</span>
                  {{ item.price }}</span
                >
                <span v-if="item.info == '₺'">&nbsp;TL</span>
                <span v-else-if="item.info == '€'">&nbsp;EUR</span>
                <span v-else-if="item.info == '$'">&nbsp;USD</span>
              </div>
              <div
                class="accordion-wrapper__row__cell"
                v-if="!item.totalPrice && !item.price"
              >
                <span class="my__price">-</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="packageDetail">
      <package-settigns
        :dataItem="packageDetail"
        :marketInfo="marketInfo"
        :isPopupVisible="isPopupVisible"
        @close="closePopup"
      />
    </template>
    <modal
      height="auto"
      class="cancel-modal"
      :adaptive="true"
      :name="getDataItemId"
    >
      <div class="modal-heading">
        <div class="modal-title">
          <h5>Paketi İptal Etmek İstiyor musunuz?</h5>
        </div>
        <a @click="closeModal()">
          <base-icon class="close" name="close-circle" />
        </a>
      </div>
      <div class="modal-body">
        <div class="modal-body__top">
          <div class="modal-body__image">
            <img
              v-if="dataItem && dataItem.imageUrl"
              alt="product image"
              :src="dataItem.imageUrl"
              class="image"
            />
            <base-icon v-else name="no-image" class="image" />
          </div>
          <div class="modal-body__info">
            <h3 class="title" v-if="dataItem.productName">
              {{ dataItem.productName }}
            </h3>
            <p class="modal-body__info-platform">
              <span
                v-if="
                  dataItem.application != null &&
                  (dataItem.application.id == 3 || dataItem.application.id == 2)
                "
                >{{ dataItem.application.shortContent }}</span
              >
              <span
                v-else-if="
                  dataItem.research.length && dataItem.application == null
                "
                >{{ dataItem.research[0].name }}</span
              >
              <span
                v-else-if="
                  dataItem.algorithm.length &&
                  (dataItem.application.id == 4 || dataItem.application.id == 7)
                "
                >{{ dataItem.algorithm[0].name }}</span
              >
              <span v-else>{{ dataItem.platform.name }}</span>
            </p>
            <div class="modal-body__info_bes">
              <span class="m-text-grayscale-80">BES / Yatırım Fonu:</span>
              {{ formatPrice(dataItem.price.totalFundAmount) }} TL
              <span class="m-text-grayscale-80">veya Komisyon:</span>
              {{ formatPrice(dataItem.price.totalCommissionAmount) }} TL
            </div>
            <p class="modal-body__info_price">
              <template v-if="totalPriceCalc !== 0">{{
                totalPriceCalc
              }}</template>
              <template v-else>Ücretsiz</template>
            </p>
          </div>
        </div>
        <info-area :infoText="infoText"></info-area>
      </div>
      <div class="modal-bottom">
        <base-button @click="cancel(dataItem.id)">İptal Et</base-button>
      </div>
    </modal>
  </div>
</template>

<style lang="scss" scoped>
.data-request-item {
  border: 1px solid var(--color-primary-tint-second);
  width: 100%;
  background: var(--grayscale-0);
  margin-bottom: 20px;
  border-radius: var(--radius-first);

  &__top {
    justify-content: space-between;
    display: flex;
    padding: 16px 20px;
    border-bottom: solid 1px var(--grayscale-30);
    flex-wrap: wrap;

    @media (max-width: 768px) {
      flex-direction: column;
      padding: 16px 12px;
    }

    span {
      font-size: 14px;
      color: var(--grayscale-70);
      @media (max-width: 768px) {
        font-size: 12px;
      }
    }
    .left {
      flex: 0.5;
      display: flex;
      &.flex-04 {
        flex: 0.4;
      }

      @media (max-width: 768px) {
        margin-bottom: 20px;
      }

      .section {
        margin-right: 10px;
        align-items: center;
        justify-content: center;
        display: flex;
        @media (max-width: 941px) {
          flex-wrap: wrap;
          justify-content: start;
        }
        &.section-main {
          @media (max-width: 1200px) {
            flex-direction: column;
            align-items: flex-start;
          }
          @media (max-width: 640px) {
            align-self: center;
          }
        }
        img {
          width: 80px;
          @media (max-width: 768px) {
            width: 48px;
          }
        }
        .tag {
          background: var(--grayscale-20);
          padding: 4px 5px;
          margin-right: 10px;
          border-radius: var(--radius-third);
          display: flex;
          align-items: center;
          text-align: center;
          @media (max-width: 941px) {
            margin-bottom: 5px;
            padding: 2px 8px;
          }
          .text {
            font-size: 12px;
            text-overflow: ellipsis;
            display: flex;
            align-items: center;
            .marketName {
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 47px;
              display: block;
            }
            @media (max-width: 400px) {
              font-size: 10px !important;
            }
            .icon {
              width: 42px;
              margin-right: -17px;
            }
          }
        }
      }
      .section-2 {
        flex-direction: row;
        align-items: unset;
        @media (max-width: 1200px) {
          margin-top: 11px;
        }
      }
      .section-1 {
        flex-direction: column;
        align-items: start;

        @media (max-width: 768px) {
          line-height: 24px;
        }

        h5 {
          font-weight: 500;
          line-height: 25px;
          @media (max-width: 768px) {
            font-size: 14px;
            line-height: normal;
          }
        }
      }
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex: 1;
      gap: 50px;

      &.resetGap {
        gap: 15px;
      }

      &.for-button {
        align-items: flex-start;
        flex: 0;
        margin-left: 30px;
        min-width: 76px;
        @media (max-width: 768px) {
          margin-left: auto;
          margin-top: 10px;
          margin-right: 0px;
        }
      }

      @media (max-width: 1200px) {
        gap: 10px;
      }
      @media (max-width: 768px) {
        justify-content: space-evenly;
        flex-wrap: wrap;
        gap: 10px 0px;
      }
      .col {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        h6 {
          line-height: 26px;
          color: var(--color-primary-black-metallic);
          font-size: 12px !important;
          font-weight: 600;
          @media (max-width: 600px) {
            line-height: normal;
          }
        }
        span {
          color: var(--grayscale-120);
          display: flex;
          justify-content: center;
          font-size: 12px;
          font-weight: 400;
          .tooltip svg {
            transform: scale(0.7);
            margin-top: -5px;
          }
        }
      }
      .button-area {
        padding: 0px;
        width: auto;
        font-size: 14px;
        text-align: center;
        cursor: pointer;
        font-weight: 500;
        position: relative;
        display: flex;
        flex: 1;
        align-items: center;

        &.d-none {
          display: none;
        }
        .text {
          margin-left: 5px;
          color: var(--color-primary-default);
        }
        .dropdown {
          visibility: hidden;
          opacity: 0;
          position: absolute;
          width: 165px;
          right: 0;
          top: 20px;
          background-color: #fff;
          border-radius: var(--radius-first);
          box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.4);
          z-index: 1;
          padding: 7px 0;
          &-item {
            padding: 7px 15px;
            text-align: left;
            &:hover {
              background: #e9e9eb;
            }
            &__text {
              font-size: 14px;
            }
          }
        }
        &:hover {
          .dropdown {
            visibility: visible;
            opacity: 1;
          }
        }
      }
    }
    &.wEndDate {
      .for-button {
        display: none;
      }
    }
  }
  &__middle {
    padding: 10.25px 20px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    @media (max-width: 768px) {
      padding: 15px 0px 12px 0px;
      flex-direction: column;
      line-height: 24px;
    }

    @media (max-width: 320px) {
      justify-content: center;
    }

    .left,
    .right {
      display: flex;
      align-items: center;
      .item {
        &.integration-warning {
          svg {
            filter: invert(31%) sepia(71%) saturate(7020%) hue-rotate(351deg)
              brightness(89%) contrast(131%);
            transition: all 1s ease-in;
            @mixin rotationBell($animationName, $animationTime) {
              -webkit-animation: #{$animationName} #{$animationTime} infinite;
              -moz-animation: #{$animationName} #{$animationTime} infinite;
              animation: #{$animationName} #{$animationTime} infinite;
            }

            @mixin keyframes($animationName) {
              @-webkit-keyframes #{$animationName} {
                @content;
              }

              @-moz-keyframes #{$animationName} {
                @content;
              }

              @keyframes #{$animationName} {
                @content;
              }
            }
            @include rotationBell(rotateAnimation, 0.5s);

            @include keyframes(rotateAnimation) {
              0% {
                transform: rotate(0deg);
              }
              25% {
                transform: rotate(15deg);
              }
              50% {
                transform: rotate(0deg);
              }
              75% {
                transform: rotate(-15deg);
              }
              100% {
                transform: rotate(0deg);
              }
            }
          }
        }
        span {
          color: var(--grayscale-70);
        }
        strong {
          font-size: 12px;
          font-weight: bold;
        }
      }
    }
    .left {
      display: flex;
      justify-content: space-between;
      align-items: center;

      @media (max-width: 650px) {
        padding-top: 10px;
        flex-wrap: wrap;
        justify-content: center;
        margin-bottom: 23px;
      }

      @media (max-width: 768px) {
        padding: 0px;
        justify-content: center;
        flex-direction: column;

        &.package-container {
          width: 100%;
          .item {
            width: 100%;
            text-align: center;
            flex-flow: unset;
            flex-wrap: wrap;
          }
        }
      }
      .item {
        display: flex;
        gap: 3px;
        font-size: 12px;

        &:nth-child(2) {
          @media (max-width: 375px) {
            display: block;
            width: 100%;
            text-align: center;
          }
          span {
            margin: 0px 5px;
          }
        }
      }
    }
    .right {
      @media (max-width: 768px) {
        width: 100%;
        flex-wrap: wrap;
        justify-content: center;
        flex-direction: column;
        margin-bottom: 10px;
        line-height: 24px;
      }
    }
  }
  &__bottom {
    display: flex;
    align-items: center;
    background: var(--grayscale-140);
    font-size: 12px;
    justify-content: space-between;
    flex-wrap: wrap;

    @media (max-width: 768px) {
      position: relative;
      align-items: flex-start;
      line-height: 24px;
    }
    .toggle {
      transform: rotate(180deg);
      transition: 0.2s ease-in-out;
      &.active {
        transform: rotate(0deg);
        transition: 0.2s ease-in;
      }
    }
    .left {
      padding: 21px 20px;
      flex: 0.99;
      @media (max-width: 768px) {
        padding: 12px;
      }
      .item {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        @media (max-width: 768px) {
          justify-content: center;
        }
        strong {
          margin-right: 10px;
          font-weight: bold;

          @media (max-width: 768px) {
            width: 100%;
            margin-bottom: 0px;
          }
        }
        .items {
          display: flex;
          align-items: center;
          &.hide {
            display: none;
          }
          @media (max-width: 768px) {
            justify-content: center;
            flex: 0 1 auto;
          }
        }
        .seperator {
          width: 1px;
          height: 22px;
          display: inline-block;
          margin: 0px 10px;
          background: var(--grayscale-130);
          @media (max-width: 768px) {
            margin: 6px 9px;
          }
        }
      }
    }
    .right {
      align-items: center;
      cursor: pointer;
      padding: 0px 20px;

      @media (max-width: 768px) {
        padding: 0px;
        position: absolute;
        right: 10px;
        top: 10px;
      }
    }
    &__packages {
      width: 100%;

      .accordion-wrapper {
        position: relative;
        display: table;
        width: 100%;
        border: 1px solid var(--color-primary-tint-second);
        @media (max-width: 768px) {
          display: block;
        }
        &__row,
        &__row__cell {
          padding: 13px 20px;
        }

        &__row {
          display: table-row;
          @media (max-width: 768px) {
            display: flex;
            padding: 12px 0px 0px 0px;
            flex-wrap: wrap;
            border-bottom: 1px solid var(--color-primary-tint-second);
          }
          &:nth-child(2n) {
            background: var(--color-primary-zebra);
          }

          &.caption {
            display: none;
            background-color: var(--grayscale-160);
            font-size: 12px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            position: sticky;
            top: 0px;

            &.active {
              display: table-row;
              @media (max-width: 768px) {
                display: flex;
                padding: 16px 12px;
              }
            }

            @media screen and (max-width: 768px) {
              position: sticky;
              top: 0px;
            }
            .caption {
              &:first-child {
                text-align: left;
                span {
                  font-size: 9px;
                  font-weight: 400;
                  display: block;
                }
                @media (max-width: 768px) {
                  justify-content: flex-start;
                  padding: 0px;
                  flex-wrap: wrap;
                  span {
                    width: 100%;
                  }
                }
              }
              @media (max-width: 768px) {
                &:nth-child(3) {
                  justify-content: flex-end;
                  position: relative;
                  right: 12px;
                }
              }

              &:last-child {
                @media (max-width: 768px) {
                  display: none;
                }
              }
              text-align: center;
            }
          }
          &__cell {
            display: table-cell;
            box-sizing: border-box;
            color: var(--color-primary-black-metallic);
            border-top: 1px solid #ecedef;
            .next-month {
              display: block;
            }
            @media (max-width: 768px) {
              display: flex;
              width: calc(100% / 3);
              justify-content: center;
              padding: 0px;
              font-size: 12px;
              align-items: center;
              border: none;
              line-height: normal;
              &:first-child {
                justify-content: flex-start;
                padding-left: 12px;
              }
              &:last-child {
                flex-basis: 100%;
                justify-content: flex-end;
                border-top: 1px solid var(--color-primary-tint-second);
                border-bottom: 1px solid var(--color-primary-tint-second);
                padding-right: 12px;
                min-height: 32px;
              }
              &:not(.caption):not(:last-child) {
                min-height: 58px;
              }
              &:not(.caption):nth-child(3) {
                position: relative;
                right: 12px;
                justify-content: flex-end;
              }
            }
            .xs {
              display: none;
              @media (max-width: 768px) {
                display: block;
              }
            }
            .seperator {
              display: inline-block;
              margin-left: 4px;
            }
            @media (min-width: 768px) {
              &:not(.caption) {
                min-height: 58px;
              }
              &:not(.caption):first-child {
                min-width: 300px;
              }
              &:nth-child(2) {
                width: 135px;
                padding: 13px 0px;
              }
              &:nth-child(3) {
                width: 140px;
                padding: 13px 0px;
              }
              &:nth-child(4) {
                width: 110px;
                padding-left: 0px;
              }
            }

            &:not(.caption):nth-child(2),
            &:not(.caption):nth-child(3),
            &:not(.caption):nth-child(4) {
              color: var(--grayscale-120);
              text-align: center;
            }
          }
        }

        &.active {
          .accordion-content {
            display: table-row-group;
            background: var(--grayscale-0);
            @media (max-width: 768px) {
              display: flex;
              flex-wrap: wrap;
              flex-direction: column;
            }
          }
          .collapse-icon {
            transform: rotate(0deg);
          }
        }
        .accordion-title-wrapper {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .collapse-icon {
          transform: rotate(180deg);
        }
        .accordion-content {
          display: none;
        }
      }
    }
  }
  .my__price {
    margin-left: 15px;
    &-text {
      display: none;
      @media (max-width: 768px) {
        display: inline-block;
        font-weight: 600;
        color: var(--color-primary-black-metallic);
      }
    }
  }
  &__price {
    font-size: 12px !important;
    margin-right: 20px;
    padding-right: 20px;
    color: var(--color-primary-black-metallic);
    font-weight: 600 !important;
    position: relative;
    &__text {
      font-weight: 400;
    }
    &::after {
      content: "";
      display: block;
      width: 1px;
      height: 22px;
      background: var(--color-primary-tint-second);
      position: absolute;
      right: 0px;
      top: 50%;
      transform: translateY(-50%);
    }
    @media (max-width: 768px) {
      margin-right: 0px;
      padding-right: 0px;
    }
  }
  &__status {
    color: var(--color-primary-black-metallic);
    font-size: 12px;

    &__stat {
      &.request {
        font-weight: 600;
        margin-left: 8px;
      }
      &.active {
        color: var(--color-primary-active) !important;
        margin-left: 8px;
      }
      &.passive {
        color: var(--color-warning) !important;
        margin-left: 8px;
      }
    }
  }

  .cancel-modal {
    z-index: 9999;
    .infoArea {
      position: relative;
      bottom: initial;
    }
    .modal-heading {
      height: 40px;
      border-bottom: 1px solid var(--grayscale-30);
      display: flex;
      align-items: center;
      padding: 15px 30px;
      justify-content: space-between;
      .close {
        margin: 5px;
        cursor: pointer;
      }
    }
    .modal-bottom {
      margin-top: 1em;
      border-top: 1px solid var(--grayscale-30);
      display: flex;
      justify-content: flex-end;
      padding: 15px 30px;
      .base-button {
        background-color: var(--color-warning);
        color: var(--grayscale-0);
        width: 180px;
        font-size: 15px;
      }
    }
    .modal-body {
      padding: 15px 30px;
      &__top {
        display: flex;
        align-items: center;
      }
      &__image {
        .image {
          margin-right: 30px;
          width: 96px;
          height: 140px;
          -o-object-fit: contain;
          object-fit: contain;
        }
      }
      &__info {
        &-platform {
          margin: 5px 0;
          font-size: 16px;
        }
        &_price {
          font-size: 20px;
          font-weight: bold;
          margin-top: 5px;
        }
      }
    }
  }
}
</style>
